import labels from './Labels';
export default class Label {
	constructor(dymo){
		this.dymo = dymo;
		this.label = null;
		this.labelFormat = null;
		this.labelKeys = [];
		this.labelSet = null;
		this.printer = null;
		this.init();
	}
	
	init(){
		console.log("Init label class");
		this.dymo.label.framework.trace=1;
		this.dymo.label.framework.init();
	}
	
	printers() {
		return this.dymo.label.framework.getLabelWriterPrinters();
	}
	
	setPrinter(){
		let printer = this.printers();
		if(printer.length > 0){
			this.printer = printer[0].modelName;
		}
	}
	
	setLabel(label){
		if(typeof label === "string"){
			label = labels[label];
			this.labelKeys = label.keys();
			this.labelFormat = label.format ? label.format : null;
			this.label = this.dymo.label.framework.openLabelXml(label.label())
		}else{
			this.label = this.dymo.label.framework.openLabelXml(label);
		}
	}
	
	createLabels(data, many = false){
		// console.log("Create labels")
		this.labelSet = new this.dymo.label.framework.LabelSetBuilder();
		if(!many){
			this.setLabelKeys(data)
		}else{
			for(let i in data){
				this.setLabelKeys(data[i]);
			}
		}
	}
	setLabelKeys(data){
		console.log("Adding Sample to Set:", data)
		let record = this.labelSet.addRecord();
		for(let key of this.labelKeys){
			if(data[key]){
				record.setText(key, data[key]);
			}
		}
	}
	
	print(){
		this.setPrinter();
		return new Promise((resolve, reject) => {
			console.log("Attempting to print")
			try{
				if(this.printer !== null){
					this.label.print(this.printer, '', this.labelSet);
					resolve({res: true, message: 'Printed!'})
				}else{
					resolve({res: false, message: 'No printer found'})
				}
			}catch(error){
				reject({res: false, message: error})
			}
		})
	}
}
